import { queryOptions, useQuery } from '@tanstack/react-query';

import { taxApi } from '../api/tax-api';

import { taxKeys } from './tax-keys';

export function taxRatesQueryOptions(storeId: string) {
  return queryOptions({
    queryKey: taxKeys.list(storeId),
    queryFn: () => taxApi.list(storeId),
  });
}

export function useTaxRates(storeId: string) {
  return useQuery(taxRatesQueryOptions(storeId));
}
